module.exports = __webpack_public_path__ + "c7fe7423a79fbc8c5bdf9adfb43786bd.webp";